module.exports = __webpack_public_path__ + "static/fretlink-desk-from-top-3978fe266190fbfcebcfd2f186a4e84e.jpg";